import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { API_BASE } from '../lib/api'
import { Logo } from '../components/Logo'
import '../styles/public-roadmap.css'

type State = 'loading' | 'success' | 'error'

export default function UnsubscribePage() {
    const { token } = useParams<{ token: string }>()
    const [state, setState] = useState<State>('loading')
    const [message, setMessage] = useState('')

    useEffect(() => {
        if (!token) { setState('error'); setMessage('Invalid unsubscribe link.'); return }

        fetch(`${API_BASE}/api/roadmap/unsubscribe/${token}`)
            .then(async res => {
                const json = await res.json().catch(() => ({}))
                if (res.ok) {
                    setState('success')
                    setMessage(json.message ?? "You've been unsubscribed.")
                } else {
                    setState('error')
                    setMessage(json.error ?? 'This unsubscribe link is invalid or has expired.')
                }
            })
            .catch(() => {
                setState('error')
                setMessage('Could not reach the server. Please try again later.')
            })
    }, [token])

    return (
        <div className="public-roadmap-root">
            <header className="public-roadmap-header">
                <div className="public-roadmap-header-inner">
                    <div className="public-roadmap-brand">
                        <Logo height={24} />
                        <span className="public-roadmap-subtitle">Product Roadmap</span>
                    </div>
                    <div className="public-roadmap-header-actions">
                        <Link to="/roadmap" className="btn btn-secondary">← View roadmap</Link>
                    </div>
                </div>
            </header>

            <main className="public-roadmap-content">
                <div className="confirm-card">
                    {state === 'loading' && (
                        <>
                            <div className="confirm-icon"><div className="spinner" /></div>
                            <h2>Updating your preferences…</h2>
                            <p>Just a moment.</p>
                        </>
                    )}

                    {state === 'success' && (
                        <>
                            <div className="confirm-icon confirm-icon--success">✅</div>
                            <h2>You're unsubscribed</h2>
                            <p>{message}</p>
                            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-tertiary)', marginTop: 'var(--space-3)' }}>
                                Signed-in users can manage all notification preferences from their profile.
                            </p>
                            <Link to="/roadmap" className="btn btn-primary" style={{ marginTop: 'var(--space-5)' }}>
                                View the roadmap
                            </Link>
                        </>
                    )}

                    {state === 'error' && (
                        <>
                            <div className="confirm-icon confirm-icon--error">⚠️</div>
                            <h2>Link invalid or expired</h2>
                            <p>{message}</p>
                            <Link to="/roadmap" className="btn btn-primary" style={{ marginTop: 'var(--space-5)' }}>
                                View the roadmap
                            </Link>
                        </>
                    )}
                </div>
            </main>
        </div>
    )
}
